import React from "react";
import clsx from "clsx";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useDownloadCourse } from "./hooks";
import { useWindowSize } from "@hooks";
import { Content } from "./Content";
import { Sidebar } from "./Sidebar";
// import PropTypes from "prop-types";
import styles from "./styles/DownloadCourseViewPage.module.css";

const LearningPage = () => {
  const { id: courseId, lessonId } = useParams();
  const {
    processing,
    courseInfo,
    hasNext,
    hasPrev,
    showFullSidebar,
    currentLesson,
    handleNext,
    handlePrevious,
    handleChangeLesson,
    setShowFullSidebar,
  } = useDownloadCourse(courseId, lessonId);
  const { width } = useWindowSize();

  return (
    <Container fluid className={styles.container}>
      <ToastContainer />

      <Row className={clsx("px-3", styles.header)}>
        <div>
          <Link to="/my-learning" className="mr-3">
            <i className="bi bi-book mr-2"></i>
            My learning
          </Link>
          <Link to={`/course/${courseInfo?.id}`} className={styles.courseTitle}>
            {courseInfo?.title}
          </Link>
        </div>
        <i
          className={clsx("bi bi-list-ul ml-3", styles.btnBurger)}
          onClick={() => setShowFullSidebar(!showFullSidebar)}
        ></i>
      </Row>

      <Row className={clsx("flex-grow-1", styles.body)}>
        <div
          className={clsx(styles.sidebarOverlay, {
            [styles.showOverlay]: showFullSidebar && width < 992,
          })}
          onClick={() => setShowFullSidebar(false)}
        ></div>

        <Col
          className={clsx("p-0", styles.sidebar, {
            [styles.showSidebar]: showFullSidebar,
          })}
          sm={0}
        >
          <Sidebar
            courseInfo={courseInfo}
            onChange={handleChangeLesson}
            currentLesson={currentLesson}
            processing={processing}
          />
        </Col>

        <Col className={styles.content}>
          <Container fluid className="m-0 p-0">
            <Content
              courseInfo={courseInfo}
              lesson={currentLesson}
              processing={processing}
              courseId={courseId}
              hasPrev={hasPrev}
              handlePrevious={handlePrevious}
              hasNext={hasNext}
              handleNext={handleNext}
            />
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
LearningPage.displayName = "LearningPage";

/* required: props types */
LearningPage.propTypes = {};

/* required: default props */
LearningPage.defaultProps = {};

export { LearningPage as LearningPage };
